import * as React from 'react'
const LMMeal = () => (
  <svg
    width={43}
    height={30}
    viewBox="0 0 9.2466021 9.2127733"
    fill="currentColor"
    xmlSpace="preserve"
    xmlns="http://www.w3.org/2000/svg"
  >
    <defs id="defs1" />
    <g id="layer1" transform="translate(-97.529316,-145.91345)">
      <rect
        style={{
          display: "none",
          fill: "#280b0b",
          stroke: "#ffffff",
          strokeWidth: 0.529167,
          strokeLinejoin: "round",
        }}
        id="rect9"
        width={209.38908}
        height={297.40347}
        x={-0.35489929}
        y={-12.06649}
      />
      <g id="g129">
        <path
          id="path73"
          style={{
            fill: "var(--primary)",
            fillOpacity: 1,
            stroke: "var(--primary)",
            strokeWidth: 0.114979,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="m 108.49094,148.27432 v -1.43961 c -0.13257,-0.50266 -0.40853,-0.71853 -0.71981,-0.86377 l -4.70348,0.0287 v 7.91787 h 4.44434 c 0.44332,-0.053 0.77321,-0.38959 1.03653,-0.89257 v -1.4684 h -0.74859 v -3.2823 z m -10.846565,0 v -1.43961 c 0.13257,-0.50266 0.408537,-0.71853 0.719797,-0.86377 l 4.703478,0.0287 v 7.91787 h -4.444351 c -0.443307,-0.053 -0.773184,-0.38959 -1.036494,-0.89257 v -1.4684 h 0.748577 v -3.2823 z"
        />
        <path
          style={{
            fill: "var(--accent)",
            fillOpacity: 1,
            stroke: "var(--accent)",
            strokeWidth: 0.401207,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="m 255.38054,-40.271876 h 2.47492 v 8.922446 h -2.36913 a 0.7799722,0.7799722 45 0 1 -0.77997,-0.779972 v -7.468292 a 0.67418169,0.67418169 135 0 1 0.67418,-0.674182 z"
          id="path74"
          transform="matrix(0.28658111,0,0,0.28658111,24.078667,160.20693)"
        />
        <path
          style={{
            fill: "var(--accent)",
            fillOpacity: 1,
            stroke: "var(--accent)",
            strokeWidth: 0.401207,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="m 255.38054,-40.271876 h 2.47492 v 8.922446 h -2.36913 a 0.7799722,0.7799722 45 0 1 -0.77997,-0.779972 v -7.468292 a 0.67418169,0.67418169 135 0 1 0.67418,-0.674182 z"
          id="path75"
          transform="matrix(-0.28658111,0,0,0.28658111,182.05128,160.20693)"
        />
        <path
          id="path77"
          style={{
            fill: "var(--accent)",
            strokeWidth: 0.119359,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 102.23261,147.24426 c -1.50914,-2e-5 -2.732547,1.2234 -2.732527,2.73254 -2e-5,1.50915 1.223387,2.73257 2.732527,2.73254 0.45944,-7e-5 0.89195,-0.11448 1.27196,-0.31484 v -0.76353 c -0.3523,0.27137 -0.79286,0.43337 -1.27196,0.43341 -1.15308,1.7e-4 -2.08794,-0.9345 -2.08802,-2.08758 8e-5,-1.15307 0.93494,-2.08775 2.08802,-2.08758 0.6231,5e-5 1.18184,0.27358 1.56433,0.7065 h 0.79228 c -0.47455,-0.80811 -1.35174,-1.35131 -2.35661,-1.35146 z"
        />
        <path
          id="path78"
          style={{
            fill: "var(--accent)",
            strokeWidth: 0.074502,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 102.16196,148.27125 c -0.94198,-2e-5 -1.70583,0.76337 -1.70582,1.70537 0,0.0122 5.1e-4,0.0242 7.6e-4,0.0364 h 0.40243 c -2.6e-4,-0.0121 -7.6e-4,-0.0243 -7.6e-4,-0.0364 5e-5,-0.71973 0.58365,-1.30305 1.3034,-1.30295 0.22173,2e-5 0.4304,0.0559 0.61307,0.1536 v -0.44239 c -0.19017,-0.0735 -0.39698,-0.11361 -0.61308,-0.11363 z"
        />
        <path
          style={{
            fill: "var(--accent)",
            fillOpacity: 1,
            stroke: "none",
            strokeWidth: 0.114979,
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeDasharray: "none",
            strokeOpacity: 1,
          }}
          d="m 106.17164,148.89922 v 3.99021 h -0.79266 l 0.0336,-0.4279 c -0.0107,-0.2277 0.0406,-0.83215 0.23939,-1.36962 h -0.46093 c -0.0456,-1.16983 0.31778,-1.85785 0.98075,-2.19269 z"
          id="path79"
        />
        <path
          id="rect80"
          style={{
            fill: "var(--accent)",
            strokeWidth: 0.130562,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          d="m 103.85363,148.9444 v 1.40265 h 0.30767 l -0.15317,2.43519 c 0.32845,0.20388 0.61359,0.14758 0.88346,0 l -0.16438,-2.43519 h 0.31888 v -1.40265 c -0.094,-0.1066 -0.17253,-0.0734 -0.24657,0 v 0.99303 c -0.0709,0.0593 -0.1478,0.0789 -0.24075,0 v -0.99303 c -0.10449,-0.11596 -0.17418,-0.0695 -0.23894,0 v 0.99303 c -0.0709,0.0593 -0.14778,0.0789 -0.24073,0 v -0.99303 c -0.10104,-0.12078 -0.16387,-0.0631 -0.22547,0 z"
        />
        <rect
          style={{
            fill: "currentColor",
            fillOpacity: 0,
            strokeWidth: 0.151553,
            strokeLinecap: "round",
            strokeLinejoin: "round",
          }}
          id="rect2"
          width={1.2804636}
          height={1.1628497}
          x={102.64044}
          y={145.91344}
        />
      </g>
    </g>
  </svg>
)

export default LMMeal
